import * as React from 'react'
import s from './tickets-list-container.scss'

export const TicketsListContainer: React.FC = ({children}) => <ul className={s.list}>{children}</ul>
